module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.value.show),
      callback: function($$v) {
        _vm.value.show = $$v
      },
      expression: "value.show"
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('div', {
    staticClass: "ls-modal-header"
  }, [_c('button', {
    attrs: {
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "ls-modal-title"
  }, [_vm._v(_vm._s(_vm.$t('invoices.modal_cancel_tax_invoice.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-body"
  }, [_c('div', {
    staticClass: "ls-md-margin-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('invoices.modal_cancel_tax_invoice.info'))
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "row"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('invoices.modal_cancel_tax_invoice.reason')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-md-12",
    attrs: {
      "type": "text",
      "name": _vm.$t('invoices.modal_cancel_tax_invoice.input')
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('invoices.modal_cancel_tax_invoice.reason'))),
      expression: "errors.has($t('invoices.modal_cancel_tax_invoice.reason'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('invoices.modal_cancel_tax_invoice.reason'))))])])]), _vm._v(" "), _c('div', {
    staticClass: "ls-modal-footer ls-md-margin-top"
  }, [_c('button', {
    staticClass: "ls-btn",
    attrs: {
      "close-modal": "",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.close')))]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn-danger ls-float-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendCancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.modal_cancel_tax_invoice.confirm')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c339792"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/invoices/components/ModalCancelTaxInvoice.vue
// module id = 747
// module chunks = 1